/**
 * What's New release notes.
 *
 * Plain array — newest first. Each entry shows:
 *  - `version` — semver-ish label rendered as a small pill
 *  - `date`    — YYYY-MM-DD, used both for display and the
 *                "last seen" cookie key so we can highlight unread
 *                releases since the user's last visit
 *  - `title`   — punchy one-liner
 *  - `body`    — short paragraph or bullet block
 *  - `tone`    — "feature" (new feature, default) / "fix" / "ops"
 *
 * Edit this file only. The modal renders the array verbatim — no
 * backend round-trip, so updates land the moment the frontend rebuilds.
 */
export const RELEASE_NOTES = [
  {
    version: "v77.99.20",
    date: "2026-02-13",
    title: "Refactor scoreboards, pending-invite promotion & yearly upsell",
    tone: "ops",
    body: [
      "Admin: new \"Refactor scoreboard\" and \"Frontend health scoreboard\" panels in the Operations console. Line counts, handler distribution, and a monolith ratio so the codebase doesn't drift back into one giant file.",
      "Admin: new \"Promote pending invites\" tool — convert a stuck child-invite into a placeholder co-parent so the primary parent can immediately log expenses, events and messages attributed to them.",
      "New /app/upgrade/yearly page — save €32.88/year (~ 3 months free) by switching to the annual plan.",
      "Calendar: filters and visible-event predicate now share one hook (`useCalendarFilters`) so child-specific filtering can't drift from the chip UI.",
    ],
  },
  {
    version: "v77.99.19",
    date: "2026-02-13",
    title: "Faster page loads · big internal cleanup",
    tone: "feature",
    body: [
      "Backend modularised: every HTTP handler now lives in its domain module under `routes/` instead of one 10k-line file. Same APIs, same behaviour — faster to ship new features safely.",
      "Expenses page: ~45% smaller after extracting the row, all 7 dialogs, summary card, per-child summary, scope breadcrumb, and child picker into reusable components.",
      "Calendar page: ~36% smaller after pulling the schedule banners, parenting-schedule dialog, recurrence and reminder fields into their own module.",
    ],
  },
  {
    version: "v77.99.18",
    date: "2026-02-12",
    title: "No more duplicate expenses or messages",
    tone: "fix",
    body: [
      "Every mutation now carries an `Idempotency-Key` header. If your phone retries a flaky request, the second send is collapsed into a replay of the first — so an expense, message, request, or settlement can never be created twice from a single tap.",
    ],
  },
  {
    version: "v77.99.16",
    date: "2026-02-10",
    title: "Marketing landing pages · admin broadcast banners",
    tone: "feature",
    body: [
      "Marketing: 6 unlinked, UTM-aware feature landing pages for ad campaigns with A/B headline variants.",
      "Admin: global broadcast banner controls — push a site-wide message (or maintenance notice) in one click.",
      "Admin: editable test-email exclusion patterns so internal accounts don't pollute revenue dashboards.",
    ],
  },
];

/**
 * Most recent release date — used by the sidebar nav badge to flag
 * unread notes since the user's last visit. Plain string compare
 * works because dates are ISO YYYY-MM-DD.
 */
export const LATEST_RELEASE_DATE = RELEASE_NOTES[0]?.date || "";
export const LATEST_RELEASE_VERSION = RELEASE_NOTES[0]?.version || "";
